import { Action } from '@ngrx/store';
import { CountryInterface } from '../../models/country.interface';

export enum ECountriesActions {
  GetCountries = '[COUNTRIES] Get countries',
  GetCountriesSuccess = '[COUNTRIES] Get countries success',
  GetCountriesFailure = '[COUNTRIES] Get countries failure',
}

/**
 * Get countries action and state to save in store
 */
export class GetCountries implements Action {
  public readonly type = ECountriesActions.GetCountries;
}

/**
 * Get countries success action and state to save in store
 */
export class GetCountriesSuccess implements Action {
  public readonly type = ECountriesActions.GetCountriesSuccess;
  constructor(public payload: Array<CountryInterface>) {}
}

/**
 * Get countries failure action and state to save in store
 */
export class GetCountriesFailure implements Action {
  public readonly type = ECountriesActions.GetCountriesFailure;
}

/**
 * Export actions
 */
export type CountriesActions = GetCountries | GetCountriesSuccess | GetCountriesFailure;
